const useRegionSwitcherRedesign =
  process.env.GATSBY_SHOW_REGION_SWITCHER_REDESIGN

export default useRegionSwitcherRedesign
